module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-2-f3fdf355d902560ac29d4850c9fe3f1c.webp";